import { Injectable } from '@angular/core';
import { ToastaConfig, ToastaService } from 'ngx-toasta';
import { TipoToasta } from '../enums/Toasta.enum';
// 2021-08-15 (aaangeles) CREACION
@Injectable({providedIn: 'root'})
export class NotificationService {
    public objToast = {
        title           : ""
    ,   msg             : ""
    ,   showClose       : true
    ,   showDuration    : false
    ,   theme           : "default"
    ,   timeout         : 7000
    }
    constructor(
        private toastaService: ToastaService,
        private toastaConfig: ToastaConfig,
    ) {
        this.toastaConfig.limit = 10;
    }

    public ShowToasta(Mensaje : string, type : TipoToasta, expired? : number) {
        this.objToast.msg = Mensaje;
        this.toastaConfig.timeout = expired != undefined && expired >= 0 ? expired : this.CalculaTiempo(Mensaje);
        switch (type) {
            case 1:
                this.objToast.title = "¡Error!";
                this.toastaService.error(this.objToast);
                break;
            case 2:
                this.objToast.title = 'Info:';
                this.toastaService.info(this.objToast);
                break;
            case 3:
                this.objToast.title = '¡Éxito!';
                this.toastaService.success(this.objToast);
                break;
            case 4:
                this.objToast.title = '¡Advertencia!';
                this.toastaService.warning(this.objToast);
                break;
            case 5:
                this.objToast.title = 'Mensaje:';
                this.toastaService.default(this.objToast);
                break;
            case 6:
                this.objToast.title = 'Procesando:';
                this.toastaService.wait(this.objToast);
                break;
            default:
                break;
        }
    }

    private CalculaTiempo(cadena): number {
        return cadena.length * 130;
    }
}